import React from 'react';
import { Alert } from 'react-bootstrap';

export const GlobalAlert = ({ message, onClose, variant = "danger" }) => {
  if (!message) return null;
  return (
    <Alert variant={variant} dismissible onClose={onClose}>
      {message}
    </Alert>
  );
};
